// Keyboard navigation of the Home View: the list of connected file systems,
// saved connections and file systems that can be connected. It follows the
// file list: arrows or j / k move the selection.

// Returns the index of the item to select after key was pressed with the
// item at idx selected, out of n items, or -1 if the key does not move the
// selection.
export function homeViewNextIdx(key: string, idx: number, n: number, pageSize = 10): number {
  if (n <= 0) {
    return -1;
  }
  let next: number;
  switch (key) {
    case "ArrowUp":
    case "k":
      next = idx - 1;
      break;
    case "ArrowDown":
    case "j":
      next = idx + 1;
      break;
    case "PageUp":
      next = idx - pageSize;
      break;
    case "PageDown":
      next = idx + pageSize;
      break;
    case "Home":
      next = 0;
      break;
    case "End":
      next = n - 1;
      break;
    default:
      return -1;
  }
  return Math.max(0, Math.min(n - 1, next));
}
